.title {
    line-height: var(--mantine-spacing-lg);
    color: var(--mantine-color-text);
}
